import { Link } from "react-router-dom";
import "./homepage.css";
import Seo from "../../components/seo/Seo";

const landingPages = {
    1: require("../../static/afbeeldingen/landing-pages/landing-page-januari-01.png"),
    2: require("../../static/afbeeldingen/landing-pages/landing-page-febrauri-01.png"),
    3: require("../../static/afbeeldingen/landing-pages/landing-page-maart-01.png"),
    4: require("../../static/afbeeldingen/landing-pages/landing-page-april-01.png"),
    5: require("../../static/afbeeldingen/landing-pages/landing-page-mei-01.png"),
    6: require("../../static/afbeeldingen/landing-pages/landing-page-juni-01.png"),
    7: require("../../static/afbeeldingen/landing-pages/landing-page-juli-01.png"),
    8: require("../../static/afbeeldingen/landing-pages/landing-page-augustus-01.png"),
    9: require("../../static/afbeeldingen/landing-pages/landing-page-september-01.png"),
    10: require("../../static/afbeeldingen/landing-pages/landing-page-oktober-01.png"),
    11: require("../../static/afbeeldingen/landing-pages/landing-page-november-01.png"),
    12: require("../../static/afbeeldingen/landing-pages/landing-page-december-01.png"),
};

const highlights = [
    {
        title: "Voeding",
        text: "Praktisch advies dat past bij uw gezondheid, dagelijks leven en persoonlijke doelen.",
    },
    {
        title: "Beweging",
        text: "Samen zoeken we naar haalbare stappen die energie geven en vol te houden zijn.",
    },
    {
        title: "Ontspanning",
        text: "Meer balans door aandacht voor rust, herstel en een leefstijl die bij u past.",
    },
];

const promises = [
    "Persoonlijke begeleiding in Breda",
    "Aandacht voor voeding, beweging en ontspanning",
    "Haalbare doelen die in het dagelijks leven passen",
];

export default function Homepage() {
    const currentMonth = new Date().getMonth() + 1;
    const currentLandingPage = landingPages[currentMonth];

    return (
        <>
            <Seo
                title="Diëtist Breda | Voedingsadvies en leefstijlbegeleiding"
                description="Vandaag Begin Ik is de diëtistenpraktijk van Rita Wilschut in Breda voor persoonlijk voedingsadvies, dieetadvies en leefstijlbegeleiding."
                path="/"
            />

            <section className="hero">
                <div className="hero__content">
                    <p className="section-label">Vandaag Begin Ik</p>
                    <h1>Een moderne praktijk voor een gezondere leefstijl in Breda.</h1>
                    <p className="hero__lead">
                        Persoonlijk voedingsadvies, dieetadvies en leefstijlbegeleiding in Breda, met
                        oog voor wat haalbaar is in uw dagelijks leven.
                    </p>

                    <div className="hero__actions">
                        <Link className="button-primary" to="/contact">
                            Neem contact op
                        </Link>
                        <Link className="button-secondary" to="/consult">
                            Bekijk consulten
                        </Link>
                    </div>

                    <div className="hero__promises">
                        {promises.map((item) => (
                            <span key={item}>{item}</span>
                        ))}
                    </div>
                </div>

                <div className="hero__visual">
                    <img
                        src={currentLandingPage}
                        alt="Vandaag Begin Ik diëtistenpraktijk in Breda"
                    />
                </div>
            </section>

            <section className="section-grid">
                <div className="section-heading">
                    <p className="section-label">Passend advies</p>
                    <h2>Gezond leven hoeft niet ingewikkeld te zijn.</h2>
                    <p>
                        Bij Vandaag Begin Ik in Breda wordt gestreefd naar haalbare doelen op het gebied van
                        voeding, beweging en ontspanning. Eenvoudig en passend in het dagelijks leven.
                    </p>
                </div>

                <div className="highlight-grid">
                    {highlights.map((item) => (
                        <article className="highlight-card" key={item.title}>
                            <h3>{item.title}</h3>
                            <p>{item.text}</p>
                        </article>
                    ))}
                </div>
            </section>

            <section className="showcase">
                <div className="showcase__image">
                    <img
                        src={require("../../static/afbeeldingen/meloen-compressed.jpg")}
                        alt="Voedingsadvies en leefstijladvies bij diëtist in Breda"
                    />
                </div>
                <div className="showcase__content">
                    <p className="section-label">Voor wie</p>
                    <h2>Voor mensen die richting zoeken in gezondheid en leefstijl.</h2>
                    <p>
                        Of het nu middels vrienden, familie of social media is, we krijgen veel
                        informatie tot ons om aan onze gezondheid te werken. Maar soms vraagt u zich af
                        of u wel het juiste pad bewandelt.
                    </p>
                    <p>
                        Genieten van het eten en energie halen uit activiteiten staan voorop. Het doel is
                        een aanpak die niet alleen goed voelt, maar ook vol te houden is.
                    </p>
                </div>
            </section>
        </>
    );
}
